module.exports = __webpack_public_path__ + "aadf7951d0bf3732c02f3ef55b6739ee.png";